import { latexExportsJson } from "@corca/data/latex-exports";

// not a comprehensive list of math commands
const mathCommands = [
  "frac",
  "left",
  "right",
  "sum",
  "prod",
  "int",
  "oint",
  "over",
  "sqrt",
  "langle",
  "rangle",
  "hat",
  "tilde",
  "cal",
  "vec",
  "infty",
  "mathcal",
  "times",
  "prime",
  "pm",
  "to",
  "sin",
  "cos",
  "overline",
  "otimes",
  "oplus",
  "equiv",
  "ln",

  "leftarrow",
  "rightarrow",
  "leftrightarrow",
  "uparrow",
  "downarrow",
  "mapsto",
  "longmapsto",
  "nearrow",
  "swarrow",
  "forall",
  "re",
  "im",
  "nabla",
  "exists",
  "emptyset",
  "varnothing",
  "wp",
  "complement",
  "neg",
  "cdots",
  "surd",
  "times",
  "cdot",
  "div",
  "cap",
  "cup",
  "neq",
  "leq",
  "geq",
  "in",
  "perp",
  "notin",
  "subset",
  "simeq",
  "approx",
  "wedge",
  "vee",
  "cong",

  // TODO: list specific environments valid in math mode
  // "begin",
  // "end",

  ...Object.values(latexExportsJson)
    .map((l) => l.imports ?? [])
    .flat()
    .map((c) => c.replace(/^\\/, "")),
];

const textCommands = [
  "begin",
  "end",
  "title",
  "author",
  "section",
  "subsection",
  "colorbox",
  // TODO: fill this in
];

const anyCommands = [...textCommands, ...mathCommands];

export function indexOfCommand(text: string, commands: string[]) {
  let pos = 0;
  while (true) {
    pos = text.indexOf("\\", pos);
    if (pos === -1) break;
    for (const cmd of commands) {
      if (text.indexOf(cmd, pos + 1) === pos + 1) {
        if (pos + cmd.length + 1 === text.length) {
          return [pos, cmd] as const;
        }
        const nextChar = text.charCodeAt(pos + cmd.length + 1);
        if (nextChar < 97 || nextChar > 122) {
          return [pos, cmd] as const;
        }
      }
    }
    pos += 1;
  }
  return [-1, null] as const;
}

export function indexOfMathCommand(text: string) {
  return indexOfCommand(text, mathCommands);
}

export function indexOfTextCommand(text: string) {
  return indexOfCommand(text, textCommands);
}

export function indexOfAnyCommand(text: string) {
  return indexOfCommand(text, anyCommands);
}
